import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const SuggestNewCouponHeading = (props) => (
  <Breadcrumb {...props}>
    <BreadcrumbItem href={LINKS.COUPONS}>
      {placeholder('breadcrumbs.coupons')}
    </BreadcrumbItem>
    <BreadcrumbItem>{placeholder('breadcrumbs.suggestCoupon')}</BreadcrumbItem>
  </Breadcrumb>
);

export default SuggestNewCouponHeading;
